module.exports = __webpack_public_path__ + "img/user-icon-logged.5d6ed8d7.svg";